import React from 'react'
import HeroSection from '../Components/faq/hero'
import FAQSection from '../Components/faq/faq'

const faq = () => {
  return (
    <div>
     <HeroSection/>
     <FAQSection />
    </div>
  )
}

export default faq
